import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = self.customSetting.BoardController;
const getController = self.customSetting.getBoard;
const postController = self.customSetting.postBoard;

export default {
  // 5-3
  QryBBS: () => {
    return axios.get(`${baseApi}/${getController}/QryBBS`);
  },
  InsBBS: (context, data) => {
    return axios.post(`${baseApi}/${postController}/InsBBS`, data);
  },
  EditBBS: (context, data) => {
    return axios.post(`${baseApi}/${postController}/EditBBS`, data);
  },
  DeleteBbsNotify: (context, data) => {
    return axios.post(`${baseApi}/${postController}/DeleteBbsNotify`, data);
  },
  DeleteBbsFile: (context, data) => {
    return axios.post(`${baseApi}/${postController}/DeleteBbsFile`, data);
  },
  QryFileList: (context, bbs_No) => {
    return axios.get(
      `${baseApi}/${getController}/QryFileList?bbs_No=${bbs_No}`
    );
  },

  // 5-4
  getBbsLocation: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryBbsLocation`)
        .then((res) => {
          context.commit("GET_BBSLOCATION_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getBbsHistory: (context, { bbsCat, aging, locationId }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QryBbsHistory?bbsCat=${bbsCat}&aging=${aging}&locationId=${locationId}`
        )
        .then((res) => {
          context.commit("GET_BBSHISTORY_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getBbsHistoryDetail: (context, { bbsNo }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryBbsHistoryDetail?bbsNo=${bbsNo}`)
        .then((res) => {
          context.commit("GET_BBSHISTORY_DETAIL", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
